export default __webpack_public_path__ + "static/media/thank-you-forAllYouDo.f3e79122.webp";